<template>
  <div v-if="computedShow" class="transaction-modal-component">
    <v-dialog
      v-model="computedShow"
      :persistent="true"
      width="900"
      content-class="transaction-modal-component"
    >
      <v-row>
        <v-col sm="5" class="left-side-menu">
          <v-btn
            class="button-cancel"
            height="80px"
            width="100%"
            color="#ffffff"
            elevation="1"
            :disabled="isCancelLoading || showCompletedWindow"
            :loading="isCancelLoading"
            @click="cancelTransaction"
          >
            <font-awesome-icon icon="times" color="red" />
            Отмена
          </v-btn>

          <transaction-person :transaction="transaction" />

          <div class="transaction-currency-section">
            <transaction-currency
              v-model="currentCurrency"
              :transaction="transaction"
              :disabled="isCurrencyDisabled"
              :hide-checks="isTerminalDisabled"
            />
          </div>
        </v-col>
        <v-col sm="7" class="right-side-menu">
          <span v-if="!showCompletedWindow && !isLoading" class="modal-title font-weight-medium">{{ getModalTitle }}</span>

          <div v-if="isLoading" class="loading-section d-flex flex-column flex-column justify-space-between" style="height: 90%">
            <span class="modal-title font-weight-medium">{{ getModalTitle }}</span>
            <icon-loading />
            <span class="text-h3 font-weight-medium mt-4 d-block text-center">Ожидание подтверждения<br />транзакции курьером</span>
          </div>

          <transaction-results
            v-if="showCompletedWindow"
            :status="transactionStatus"
            :transaction="transactionResults"
            :results="transactionResults"
            @close="computedShow = false"
          />

          <template v-if="!isLoading && !showCompletedWindow">
            <div class="transaction-calc-section">
              <div class="transaction-calc">
                <transaction-calc
                  v-model="amount"
                  :currency="currentCurrency"
                  :transaction="transaction"
                  :checks.sync="checks"
                />
              </div>
              <v-btn
                class="button-primary text-sm-h3 mb-5"
                height="80px"
                block
                :disabled="isCreateButtonDisabled"
                @click="updateTransaction"
              >
                <font-awesome-icon icon="check" class="mr-2" />
                Создать транзакцию
              </v-btn>
            </div>
          </template>
        </v-col>
      </v-row>
    </v-dialog>
  </div>
</template>

<script>
  import TransactionPerson from '../transaction-components/transaction-person/TransactionPerson'
  import TransactionCurrency from '../transaction-components/transaction-currency/TransactionCurrency'
  import TransactionCalc from '../transaction-components/transaction-calc/TransactionCalc'
  import TransactionResults from '../transaction-components/transaction-results/TransactionResults'
  import IconLoading from '../transaction-components/IconLoading'
  import mixinTransaction from '@/mixins/transactions'

  export default {
    name: 'TransactionModal',
    components: {
      TransactionPerson,
      TransactionCurrency,
      TransactionCalc,
      TransactionResults,
      IconLoading,
    },
    mixins: [mixinTransaction],
    props: {
      transaction: {
        type: Object,
        default: () => ({}),
      },
      show: Boolean,
    },
    data () {
      return {
        isCurrencyDisabled: false,
        showCompletedWindow: false,
        isCancelLoading: false,
        isLoading: false,
        reqInterval: null,
        transactionStatus: null,
        amount: 0,
        checks: 0,
        currentCurrency: 'cash',
        transactionResults: {},
      }
    },
    computed: {
      isCreateButtonDisabled () {
        return (!this.amount && !this.checks) || this.amount < 0 || this.checks < 0
      },
      isTerminalDisabled () { return this.transaction && this.transaction.operationType === 'receive' },
      computedShow: {
        get () {
          return this.show
        },
        set (value) {
          this.$emit('update:show', value)
        },
      },
      getModalTitle () {
        if (this.transaction.operationType === 'send') {
          return 'Пополнение кассы'
        }
        if (this.transaction.operationType === 'receive') {
          return 'Выдача денег на сдачу'
        }
        return 'Транзакция'
      },
    },
    watch: {
      show () {
        if (this.show) {
          this.reqInterval = null
          this.amount = 0
          this.checks = 0
          if (this.transaction?.operationType === 'send' && this.transaction?.fCashBefore === 0) {
            this.currentCurrency = 'terminal'
          } else {
            this.currentCurrency = 'cash'
          }
          this.isLoading = false
          this.showCompletedWindow = false
          this.isCurrencyDisabled = false
        }
      },
      currentCurrency () {
        this.amount = 0
        this.checks = 0
      },
    },
  }
</script>
